module.exports = __webpack_public_path__ + "static/media/blind.f0a76be3.svg";